export const MAX_DECIMAL_VALUE = 99999999.9999;

export function normalizeDecimalInput(value, maxDecimalPlaces = 4) {
  const normalized = String(value ?? "")
    .replace(/\./g, ",")
    .replace(/[^\d,]/g, "");
  const [integerPart = "", ...decimalParts] = normalized.split(",");
  const decimalPart = decimalParts.join("").slice(0, maxDecimalPlaces);
  const integer = integerPart.slice(0, 8);

  if (!normalized) return "";
  if (normalized.includes(",")) return `${integer},${decimalPart}`;
  return integer;
}

export function parseDecimalInput(value) {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(String(value).replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatDecimalInput(value, maximumFractionDigits = 4) {
  if (value === null || value === undefined || value === "") return "";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "";
  return parsed.toLocaleString("es-AR", {
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits,
  });
}

export function isRichTextEmpty(value) {
  return !String(value ?? "")
    .replace(/<br\s*\/?>/gi, "")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;|\u00a0/gi, " ")
    .trim();
}
